<!-- Petite Bannière -->
<section id="banner" class="for-booking" *ngIf="!embeded">
  <div class="banner-img-wrapper flexible">
    <img src="assets/imgs/banner.png" alt="Bannière de l'évènement mis en avant" class="width-100 blured-15" *ngIf="!event?.image">
    <img src="{{event?.image|assetimage}}" onError="this.src='assets/imgs/banner.png'" alt="Bannière de l'évènement mis en avant" class="width-100 blured-15" *ngIf="event?.image">
  </div>
  <div class="container width-100 overlay flexible">
    <header>
      <h2>{{dayname}} {{day}} {{month}}</h2>
      <h1>{{event?.name}}</h1>
    </header>
  </div>
</section>

<!-- Contenu des bookings -->
<section id="booking" *ngIf="event">
  <div class="container">
    <div *ngIf="!event?.hasHousing">
     <div class="travel" *ngIf="!inscriptionMode && showSteps">
       <ul class="breakpoints-list flexible">
        <li class="passed">
          <a *ngIf="event.id!= 234" [routerLink]="['/event/'+event.id]" title="Réservation"><i class="fa fa-ticket"></i></a>
          <a *ngIf="event.id == 234" [routerLink]="['/eventandhousing/'+slugify(event.name)+'/'+event.id]" title="Réservation"><i class="fa fa-ticket"></i></a>
          <label class="text-uppercase">{{'front_booking.booking'| translate}}</label>
        </li>
        <li class="" [ngClass]="{'current': (stepIndex >= 1 || result.payment) , 'passed':(stepIndex >= 1 || result.payment)}">
          <a [routerLink]="['/booking/infos']" title="Coordonnées"><i class="fa fa-edit"></i></a>
          <label class="text-uppercase">{{'front_booking.particulars'| translate}}</label>
        </li>
        <li  class="" [ngClass]="{'current': (stepIndex >= 2 || result.payment) , 'passed': (stepIndex >= 2 || result.payment)}">
          <a href="javascript:void(0);" title="Paiement"><i class="fa fa-credit-card"></i></a>
          <label class="text-uppercase">{{'front_booking.payment'| translate}}</label>
        </li>
        <li *ngIf="!inscriptionMode" class="" [ngClass]="{'current': result.payment, 'passed':result.payment}">
          <a href="javascript:void(0);" title="Places"><i class="fa fa-check"></i></a>
          <label class="text-uppercase">{{'front_booking.seats'| translate}}</label>
        </li>
      </ul>
     </div>
    </div>

    <div *ngIf="event?.hasHousing">
      <div class="travel" *ngIf="!inscriptionMode && showSteps">
        <ul class="breakpoints-list breakpoints-listwithHousing flexible">
          <li class="passed">
            <a [routerLink]="['/event/'+event.id]" title="Réservation"><i class="fa fa-ticket"></i></a>
            <label class="text-uppercase">{{'front_booking.booking'| translate}}</label>
          </li>
          <li class="" [ngClass]="{'current': (stepIndex >= 1 || result.payment) , 'passed':(stepIndex >= 1 || result.payment)}">
            <a [routerLink]="['/booking/infos']" title="Coordonnées"><i class="fa fa-edit"></i></a>
            <label class="text-uppercase">{{'front_booking.particulars'| translate}}</label>
          </li>

          <li  class="" [ngClass]="{'current': (stepIndex >= 2 || result.payment) , 'passed': (stepIndex >= 2 || result.payment)}">
            <a [routerLink]="['/booking/housing']" href="javascript:void(0);" title="hébergement"><i class="fa fa-home"></i></a>
            <label class="text-uppercase">Hébergement</label>
          </li>

          <li  class="" [ngClass]="{'current': (stepIndex >= 3 || result.payment) , 'passed': (stepIndex >= 3 || result.payment)}">
            <a href="javascript:void(0);" title="Paiement"><i class="fa fa-credit-card"></i></a>
            <label class="text-uppercase">{{'front_booking.payment'| translate}}</label>
          </li>
          <li *ngIf="!inscriptionMode" class="" [ngClass]="{'current': result.payment, 'passed':result.payment}">
            <a href="javascript:void(0);" title="Places"><i class="fa fa-check"></i></a>
            <label class="text-uppercase">{{'front_booking.seats'| translate}}</label>
          </li>
        </ul>
      </div>
    </div>


    <div *ngIf="stepIndex == 1 || stepIndex == 2" style="margin-top: 15px">
      <app-count-down [sessionExpirationTime]="sessionExpirationTime"></app-count-down>
    </div>


   <!--<div class="time-remaining">-->
      <!--<div class="time">-->
        <!--<i class="fa fa-clock-o"></i>-->
        <!--<h3 class="inline-block">88:88</h3>-->
      <!--</div>-->
      <!--<div class="infos">-->
        <!--<span class="block text-uppercase">temps restant pour finaliser votre commande</span>-->
        <!--<span class="block text-uppercase">passé ce délais, vous devez recommencer</span>-->
      <!--</div>-->
    <!--</div>-->
  </div>

  <router-outlet ></router-outlet>
</section>
